export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/draco.worker.cf11295a.worker.js");
}
